import { popoverAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { base, variants } from '../common/TooltipAndToggletip.common';
import { rem } from '../themeUtils';

/**
 * BitkitToggletip: the tooltip's bubble on a popover, so it opens on click and tap and its link and
 * button take focus. Wider and roomier than a tooltip, since it carries an action row.
 */
const toggletipSlotRecipe = defineSlotRecipe({
  className: 'toggletip',
  slots: popoverAnatomy.keys(),
  base: {
    ...base,
    content: {
      ...base.content,
      minWidth: rem(240),
      // Without a link or a button the content itself takes focus; the global ring skips tabindex="-1".
      focusVisibleRing: 'outside',
    },
  },
  variants,
  defaultVariants: {
    variant: 'dark',
    paddingSize: 'lg',
    textStyle: 'md/regular',
  },
});

export default toggletipSlotRecipe;
